import { render } from "./MonitoringData.vue?vue&type=template&id=044add8e&scoped=true&ts=true"
import script from "./MonitoringData.vue?vue&type=script&lang=ts"
export * from "./MonitoringData.vue?vue&type=script&lang=ts"

import "./MonitoringData.vue?vue&type=style&index=0&id=044add8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044add8e"]])

export default __exports__